import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { VideoTypesDataService, VideoTypesColumnsService } from '../../../services';
import { VideoType, VideoTypesResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-video-type-details',
  templateUrl: './video-type-details.component.html',
  styleUrls: ['./video-type-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class VideoTypeDetailsComponent implements OnInit, OnDestroy {

  public videoType: VideoType = {};
  public videoTypes: VideoType[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private videoTypesDataService: VideoTypesDataService,
    private videoTypesColumnsService: VideoTypesColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Video Type - Details');
        this.getVideoType(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.videoType !== 'undefined') {
      this.videoType = this.dynamicDialogConfig.data.videoType;
    }
    this.columns = this.videoTypesColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getVideoType(id: number): void {
    this.isLoading = true;
    this.videoTypesDataService.getVideoType(id).subscribe((response: VideoType|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.videoType = response;
      }
    });
  }

  list() {
    this.router.navigate(['/video-types']);
  }

  add() {
    this.router.navigate(['/video-types/add']);
  }

  edit() {
    this.router.navigate(['/video-types/edit/' + this.videoType.id]);
  }

}
@Component({
  selector: 'app-video-type-details',
  templateUrl: './video-type-details.component.html',
  styleUrls: ['./video-type-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogVideoTypeDetailsComponent extends VideoTypeDetailsComponent {
}

